"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImgComparisonSlider = void 0;
const react_1 = require("react");
if (typeof document !== 'undefined') {
    Promise.resolve().then(() => __importStar(require('img-comparison-slider')));
}
exports.ImgComparisonSlider = (0, react_1.forwardRef)(({ children, onSlide, value, className, ...props }, ref) => {
    const sliderRef = (0, react_1.useRef)();
    (0, react_1.useEffect)(() => {
        if (value !== undefined) {
            sliderRef.current.value = parseFloat(value.toString());
        }
    }, [value, sliderRef]);
    (0, react_1.useEffect)(() => {
        if (onSlide) {
            // @ts-ignore
            sliderRef.current.addEventListener('slide', onSlide);
        }
    }, []);
    (0, react_1.useImperativeHandle)(ref, () => sliderRef.current, [sliderRef]);
    return (0, react_1.createElement)('img-comparison-slider', Object.assign({
        class: className ? `${className} rendered` : 'rendered',
        // Align tabIndex between the web and React components
        // this code could be removed when
        // https://github.com/WICG/webcomponents/issues/762 is resolved.
        tabIndex: 0,
        ref: sliderRef,
    }, props), children);
});
//# sourceMappingURL=index.js.map